import { render } from "./KioskReport.vue?vue&type=template&id=1838cbe8&scoped=true"
import script from "./KioskReport.vue?vue&type=script&lang=js"
export * from "./KioskReport.vue?vue&type=script&lang=js"

import "./KioskReport.vue?vue&type=style&index=0&id=1838cbe8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1838cbe8"]])

export default __exports__